module.exports = __webpack_public_path__ + "62fc6d2a5221099fdc42a7760a874cab.jpg";